export const orgRedirects = {
  cometsswimschool: "swim4soflo",
  swatswimamerica: "swimswatwi",
  kingfishriswimacademy: "kingfishri",
  "swim-asl": "goldswim",
};
